var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { bind as Bind } from 'bind-decorator';
import { normalizePath } from './node';
import { EndpointData } from './endpoint-data';
import { SumTreeDataService } from './sum-tree-data.service';
import { PathDataCache } from './path-data-cache';
// Cached Data was generated by saving path->xmlstrings as the app first loaded.
// Then the dictionary was transformed into json and downloaded.
// uriContent = `data:application/octet-stream,${encodeURIComponent(JSON.stringify(temp1, null, 2))}`;
// newWindow = window.open(uriContent, 'newDocument');
import * as precachedEndpointData from './cached-endpoint-data.json';
var SumTreeEndpointDataService = (function (_super) {
    __extends(SumTreeEndpointDataService, _super);
    function SumTreeEndpointDataService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.baseUrl = 'http://weber.hms.harvard.edu/HealthcareSystemDynamics/SumTreePCORI/GetChildren.asp?parent=';
        _this.cache = new PathDataCache();
        _this.seenPath = {};
        Object.entries(precachedEndpointData).forEach(function (_a) {
            var path = _a[0], xmlstring = _a[1];
            _this.seenPath[path] = true;
            _this.cache.addChildData(path, new EndpointData(xmlstring));
        });
        return _this;
    }
    SumTreeEndpointDataService.prototype.queryNodes = function (paths) {
        return this.getPathData(paths).map(function (results) {
            return results.map(function (pathData) { return pathData.singleNode; }).filter(function (d) { return !!d; });
        });
    };
    SumTreeEndpointDataService.prototype.queryChildNodes = function (paths) {
        var _this = this;
        return this.getPathData(paths).map(function (results) {
            return [].concat.apply([], results.map(function (pathData) {
                return (pathData.childPaths || []).map(function (child) { return _this.cache.getPathData(child).singleNode; });
            })).filter(function (d) { return !!d; });
        });
    };
    SumTreeEndpointDataService.prototype.querySummaryNodes = function (paths) {
        return this.getPathData(paths).map(function (results) {
            return [].concat.apply([], results.map(function (pathData) { return pathData.summaryNodes; })).filter(function (d) { return !!d; });
        });
    };
    SumTreeEndpointDataService.prototype.getPathData = function (paths, queryChildren) {
        var _this = this;
        if (queryChildren === void 0) { queryChildren = false; }
        var allPaths = (Array.isArray(paths) ? paths : [paths]);
        var queryPaths = allPaths.concat(this.getParentPaths(allPaths));
        return this.getRawDataNodes(queryPaths).map(function (results) {
            results.filter(function (ep) { return !!ep; }).forEach(function (endpointData, index) {
                _this.cache.addChildData(queryPaths[index], endpointData);
                precachedEndpointData[queryPaths[index]] = endpointData.xmlString;
            });
            return allPaths.map(_this.cache.getPathData);
        });
    };
    SumTreeEndpointDataService.prototype.getRawDataNodes = function (paths) {
        return forkJoin.apply(void 0, (Array.isArray(paths) ? paths : [paths]).map(this.queryEndpoint));
    };
    SumTreeEndpointDataService.prototype.queryEndpoint = function (path) {
        if (!this.seenPath.hasOwnProperty(path)) {
            this.seenPath[path] = true;
            return this.rawQueryEndpoint(path);
        }
        else {
            return Observable.of(null);
        }
    };
    SumTreeEndpointDataService.prototype.rawQueryEndpoint = function (path) {
        path = path.endsWith('\\') ? path : (path + '\\');
        return this.http.get(this.baseUrl + path, { responseType: 'text' })
            .map(function (xml) { return new EndpointData(xml); });
    };
    SumTreeEndpointDataService.prototype.getParentPaths = function (paths) {
        var parents = {};
        for (var _i = 0, _a = (Array.isArray(paths) ? paths : [paths]); _i < _a.length; _i++) {
            var path = _a[_i];
            var parent_1 = normalizePath(path).split('\\').slice(0, -1).join('\\');
            parents[parent_1] = true;
        }
        return Object.keys(parents);
    };
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Observable)
    ], SumTreeEndpointDataService.prototype, "queryNodes", null);
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Observable)
    ], SumTreeEndpointDataService.prototype, "queryChildNodes", null);
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Observable)
    ], SumTreeEndpointDataService.prototype, "querySummaryNodes", null);
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Observable)
    ], SumTreeEndpointDataService.prototype, "getPathData", null);
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Observable)
    ], SumTreeEndpointDataService.prototype, "getRawDataNodes", null);
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Observable)
    ], SumTreeEndpointDataService.prototype, "queryEndpoint", null);
    return SumTreeEndpointDataService;
}(SumTreeDataService));
export { SumTreeEndpointDataService };



// WEBPACK FOOTER //
// ./src/app/hsd-tree/shared/sum-tree-endpoint-data.service.ts.pre-build-optimizer.js